import React, { useState, useRef, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { parse, format } from 'date-fns';
import Chip from '@mui/material/Chip';
import {
    Popover,
    FormLabel,
    RadioGroup,
    Radio,
    IconButton,
} from "@mui/material";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

import api from '../../../../../../services/api';
import MenuRecursosFrota from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import AnexadorArquivos from "../../../../../../components/AnexadorArquivos";



const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));



export default function CadastrarOcorrencia({ flag, veiculo, closeNovaOcorrencia, closeAtualizarOcorrencia, ocorrenciaAtualizar }) {


    const [idOcorrenciaSalva, setIdOcorrenciaSalva] = useState(0);
    const anexadorRef = useRef();


    function formatarDataBR(dateObj) {
        let dia = String(dateObj.getDate()).padStart(2, '0');
        let mes = String(dateObj.getMonth() + 1).padStart(2, '0');
        let ano = dateObj.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }


    const [descricaoImagem1, setDescricaoImagem1] = useState(flag === 0 ? '' : ocorrenciaAtualizar.descricao_imagem1);
    const [descricaoImagem2, setDescricaoImagem2] = useState(flag === 0 ? '' : ocorrenciaAtualizar.descricao_imagem2);
    const [descricaoImagem3, setDescricaoImagem3] = useState(flag === 0 ? '' : ocorrenciaAtualizar.descricao_imagem3);
    const [descricaoImagem4, setDescricaoImagem4] = useState(flag === 0 ? '' : ocorrenciaAtualizar.descricao_imagem4);



    const classes = useStyles();
    const history = useHistory();

    const [tipoOcorrencia, setTipoOcorrencia] = useState(flag === 0 ? 0 : ocorrenciaAtualizar.tipo_ocorrencia);
    const [descricao, setDescricao] = useState(flag === 0 ? "" : ocorrenciaAtualizar.descricao_ocorrencia);

    const [veiculosEnvolvidos, setVeiculosEnvolvidos] = useState(flag === 0 ? "" : ocorrenciaAtualizar.veiculos_envolvidos);
    const [pessoasEnvolvidas, setPessoasEnvolvidas] = useState(flag === 0 ? "" : ocorrenciaAtualizar.pessoas_envolvidas);

    const [localAcidente, setLocalAcidente] = useState(flag === 0 ? "" : ocorrenciaAtualizar.local_acidente);
    const [usoCinto, setUsoCinto] = useState(flag === 0 ? "" : ocorrenciaAtualizar.uso_cinto);

    //  formatarDataBR(new Date(ocorrenciaAtualizar.data_ocorrencia))

    const [dataOcorrencia, setDataOcorrencia] = useState(flag === 0 ? '' : formatarDataBR(new Date(ocorrenciaAtualizar.data_ocorrencia)));
    const [horaOcorrencia, setHoraOcorrencia] = useState(flag === 0 ? '' : ocorrenciaAtualizar.hora_ocorrencia);
    const [valor, setValor] = useState(flag === 0 ? 0.0 : ocorrenciaAtualizar.valor);


    const [colaboradores, setColaboradores] = useState([]);
    const [colaboradorSelecionado, setColaboradorSelecionado] = useState(flag === 0 ? null : ocorrenciaAtualizar.responsavel);

    const [loading, setLoading] = useState(true);


    const [tiposMultas, setTiposMultas] = useState([]);



    const [tipoMultasSelecionados, setTipoMultasSelecionados] = useState(flag === 0 ? [] : ocorrenciaAtualizar.multas);


    const handleAdicionarTipoMulta = (event, newValue) => {
        // Verifica se o valor selecionado já está na lista
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];
        const novosTiposMultas = valoresSelecionados.filter(
            (opcao) => !tipoMultasSelecionados.some((selecionado) => selecionado.id_tipo_multa === opcao.id_tipo_multa)
        );

        setTipoMultasSelecionados([...tipoMultasSelecionados, ...novosTiposMultas]);
    };



    const handleRemoverTipoMulta = (event, tipoMultaRemovido) => {
        // alert("Handle remover dep chamado")
        const novosTiposMultas = tipoMultasSelecionados.filter(
            (tipo_multa) => tipo_multa.id_tipo_multa !== tipoMultaRemovido.id_tipo_multa
        );
        setTipoMultasSelecionados(novosTiposMultas);
    };





    const [tiposManutencao, setTiposManutencao] = useState([]);



    const [tipoManutencaoSelecionados, setTipoManutencaoSelecionados] = useState(flag === 0 ? [] : ocorrenciaAtualizar.manutencoes);

    // Adicionar tipo de manutenção
    const handleAdicionarTipoManutencao = (event, newValue) => {
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];

        const novosTiposManutencao = valoresSelecionados.filter(
            (opcao) => !tipoManutencaoSelecionados.some(
                (selecionado) => selecionado.id_tipo_manutencao === opcao.id_tipo_manutencao
            )
        );

        setTipoManutencaoSelecionados([...tipoManutencaoSelecionados, ...novosTiposManutencao]);
    };

    // Remover tipo de manutenção
    const handleRemoverTipoManutencao = (event, tipoManutencaoRemovido) => {
        const novosTiposManutencao = tipoManutencaoSelecionados.filter(
            (tipo) => tipo.id_tipo_manutencao !== tipoManutencaoRemovido.id_tipo_manutencao
        );

        setTipoManutencaoSelecionados(novosTiposManutencao);
    };










    const [tiposAcidentes, setTiposAcidentes] = useState([]);



    const [tiposAcidentesSelecionados, setTiposAcidentesSelecionados] = useState(flag === 0 ? [] : ocorrenciaAtualizar.acidentes);

    // Adicionar tipo de manutenção
    const handleAdicionarTipoAcidente = (event, newValue) => {
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];

        const novosTiposAcidentes = valoresSelecionados.filter(
            (opcao) => !tiposAcidentesSelecionados.some(
                (selecionado) => selecionado.id_tipo_acidente === opcao.id_tipo_acidente
            )
        );

        setTiposAcidentesSelecionados([...tiposAcidentesSelecionados, ...novosTiposAcidentes]);
    };

    // Remover tipo de manutenção
    const handleRemoverTipoAcidente = (event, acidenteRemovido) => {
        const novosTiposAcidentes = tiposAcidentesSelecionados.filter(
            (tipo) => tipo.id_tipo_acidente !== acidenteRemovido.id_tipo_acidente
        );

        setTiposAcidentesSelecionados(novosTiposAcidentes);
    }

    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }



            await api.get("v1/protected/colaboradores/listartodos", {
                headers: headers
            }).then(function (response) {
                setColaboradores(response.data)

                //listar tipo multas
                api.get("v1/protected/veiculos/ocorrencias/tipomultas/listartodos", {
                    headers: headers
                }).then(function (response) {
                    setTiposMultas(response.data)

                    api.get("v1/protected/veiculos/ocorrencias/tipomanutencao/listartodos", {
                        headers: headers
                    }).then(function (response) {
                        setTiposManutencao(response.data)

                        //listar tipo multas

                        api.get("v1/protected/veiculos/ocorrencias/tiposacidentes/listartodos", {
                            headers: headers
                        }).then(function (response) {
                            setTiposAcidentes(response.data)

                            //listar tipo multas

                            setLoading(false);


                        });


                    });



                });


            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar os Solicitantes: " + _err)

        }

    }


    useEffect(() => {
        listarInformacoes();

    }, []);



    function returnDescricaoColaborador(colaborador) {


        var texto = "Colaborador_ID: " + colaborador.id_colaborador +
            "\nCPF: " + colaborador.cpf +
            "\nNome: " + colaborador.nome + " " + colaborador.sobrenome + "\n ";
        return texto;
    }






    async function salvar() {


        try {

            if (!colaboradorSelecionado) {
                alert("Selecione o Responsável");
                return;
            }


            if (tipoOcorrencia === 0) {
                if (tipoMultasSelecionados.length === 0) {
                    alert("Especifique no mínimo um tipo de multa!");
                    return;
                }
            } else if (tipoOcorrencia === 10) {
                if (tipoManutencaoSelecionados.length === 0) {
                    alert("Especifique no mínimo um tipo de manutenção!");
                    return;
                }
            }


            console.log("cadastrar chamado");
            const cadastro = {
                veiculo_id: veiculo.id_veiculo,
                tipo_ocorrencia: tipoOcorrencia,
                descricao_ocorrencia: descricao,
                responsavel: { id_colaborador: colaboradorSelecionado.id_colaborador },
                usuario_criador: { id_usuario: Cookies.get('id_usuario') },
                valor: parseFloat(valor),
                multas: tipoMultasSelecionados,
                manutencoes: tipoManutencaoSelecionados,
                acidentes: tiposAcidentesSelecionados,
                despesas: despesas,
                veiculos_envolvidos: veiculosEnvolvidos,
                pessoas_envolvidas: pessoasEnvolvidas,
                local_acidente: localAcidente,
                uso_cinto: usoCinto,
          

            };

            if (dataOcorrencia && parse(dataOcorrencia, 'dd/MM/yyyy', new Date()) instanceof Date) {

                cadastro.data_ocorrencia = format(parse(dataOcorrencia, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
            } else {
                alert("Informe uma data válida!");
                return;
            }

            if (horaOcorrencia && parse(horaOcorrencia, 'HH:mm', new Date()) instanceof Date) {

                cadastro.hora_ocorrencia = format(parse(horaOcorrencia, 'HH:mm', new Date()), 'HH:mm');
            } else {
                alert("Informe uma hora válida!");
                return;
            }



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/veiculos/ocorrencias/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                //cadastrar arquivos
                setIdOcorrenciaSalva(cadastro_salvo.id_ocorrencia);




            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }

    useEffect(() => {
        if (idOcorrenciaSalva > 0 && anexadorRef.current) {
            anexadorRef.current.salvarArquivos();
        }
    }, [idOcorrenciaSalva]);





    const [despesas, setDespesas] = useState(flag === 0 ? [] : ocorrenciaAtualizar.despesas);

     useEffect(() => {
        if (despesas && Array.isArray(despesas)) {
            let soma_total = 0;

            despesas.forEach((despesa) => {
                const quantidade = Number(despesa.quantidade);
                const valor_unidade = Number(despesa.valor_unidade);

                // Verifica se os valores são válidos
                if (!isNaN(quantidade) && !isNaN(valor_unidade)) {
                    soma_total += quantidade * valor_unidade;
                } else {
                    console.warn("Despesa com valor inválido:", despesa);
                }
            });

            setValor(soma_total);
        }
    }, [despesas]);

    function returnDescricaoDespesa(despesa) {
        var texto = "Nome: " + despesa.nome + " | Descrição: " + despesa.descricao
            + " | Unidade: " + despesa.unidade
            + " | Quantidade: " + despesa.quantidade
            + " | Valor por Unidade: " + despesa.valor_unidade
            + " | Valor Total: " + (despesa.quantidade * despesa.valor_unidade) ;
        return texto;
    }


    const [anchorEl, setAnchorEl] = useState(false);
    const [nomeDespesa, setNomeDespesa] = useState("");
    const [descricaoDespesa, setDescricaoDespesa] = useState("");
    const [unidadeDespesa, setUnidadeDespesa] = useState("");
    const [valorUnidadeDespesa, setValorUnidadeDespesa] = useState(0.0);
    const [quantidadeDespesa, setQuantidadeDespesa] = useState(0.0);
    const [valorTotalDespesa, setValorTotalDespesa] = useState(0.0);

    const handleOpen = (event) => {
        setAnchorEl(true);
    };

    const handleClose = () => {
        setAnchorEl(false);
        setNomeDespesa("");
        setDescricaoDespesa("");
        setUnidadeDespesa("");
        setQuantidadeDespesa(0.0);
        setValorUnidadeDespesa(0.0);
        setValorTotalDespesa(0.0);
    };

    const handleAdicionarDespesa = () => {
        const novaDespesa = {
            nome: nomeDespesa,
            descricao: descricaoDespesa,
            unidade: unidadeDespesa,
            quantidade: quantidadeDespesa,
            valor_unidade: valorUnidadeDespesa,
            valor_total: valorTotalDespesa,
        };

        setDespesas([...despesas, novaDespesa]);
        setNomeDespesa("");
        setDescricaoDespesa("");
        setUnidadeDespesa("");
        setQuantidadeDespesa(0.0);
        setValorUnidadeDespesa(0.0);
        setValorTotalDespesa(0.0);
        setAnchorEl(false);
    };




    const handleRemoverDespesa = (event, despesaRemovida) => {
        // alert("Handle remover dep chamado")
        const novasDespesas = despesas.filter(
            (des) => des.id_despesa !== despesaRemovida.id_despesa
        );
        setDespesas(novasDespesas);
    };



    return (
        <>
            {!loading &&
                <Grid container spacing={2}   >
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        {flag === 0 && (
                            <Button style={{ margin: 5 }}
                                variant="contained"
                                color="primary"
                                onClick={salvar}
                            > Salvar  </Button>
                        )}
                    </Grid>

                    <Grid item xs={12}
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                    >




                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <InputLabel id="status-ocorrencia-label">Tipo Ocorrência</InputLabel>
                                <Select
                                    labelId="status-ocorrencia-label"
                                    id="status-ocorrencia"
                                    value={tipoOcorrencia}
                                    onChange={(e) => setTipoOcorrencia(e.target.value)}
                                    label="Tipo Ocorrência"
                                >
                                    <MenuItem value={0}>Multa</MenuItem>
                                    <MenuItem value={10}>Manutenção</MenuItem>
                                    <MenuItem value={20}>Acidente</MenuItem>
                                    <MenuItem value={30}>Baixa</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>


                        {tipoOcorrencia === 0 &&
                            <Grid
                                container
                                direction="row"
                                item xs={12}
                            >

                                <Grid item xs={12}  >
                                    <Autocomplete
                                        multiple
                                        id="tiposmultas"
                                        options={tiposMultas}
                                        getOptionLabel={(tipo_multa) => tipo_multa.nome}
                                        onChange={handleAdicionarTipoMulta}
                                        value={tipoMultasSelecionados}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Selecione Tipos de Multas"
                                            />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((tipo_multa, index) => (
                                                <Chip
                                                    key={index}
                                                    label={tipo_multa.nome}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                    onDelete={(event) => handleRemoverTipoMulta(event, tipo_multa)}

                                                />
                                            ))
                                        }
                                    />


                                </Grid>
                            </Grid>
                        }

                        {tipoOcorrencia === 10 &&
                            <Grid
                                container
                                direction="row"
                                item xs={12}
                            >

                                <Grid item xs={12}  >
                                    <Autocomplete
                                        multiple
                                        id="tiposmanutencao"
                                        options={tiposManutencao}
                                        getOptionLabel={(tipo_manutencao) => tipo_manutencao.nome}
                                        onChange={handleAdicionarTipoManutencao}
                                        value={tipoManutencaoSelecionados}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Selecione Tipos de Manunteção"
                                            />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((tipo_manutencao, index) => (
                                                <Chip
                                                    key={index}
                                                    label={tipo_manutencao.nome}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                    onDelete={(event) => handleRemoverTipoManutencao(event, tipo_manutencao)}

                                                />
                                            ))
                                        }
                                    />


                                </Grid>
                            </Grid>
                        }


                        {tipoOcorrencia === 20 &&
                            <Grid
                                container
                                direction="row"
                                item xs={12}
                            >

                                <Grid item xs={12}  >
                                    <Autocomplete
                                        multiple
                                        id="tiposacidentes"
                                        options={tiposAcidentes}
                                        getOptionLabel={(tipo_acidente) => tipo_acidente.nome}
                                        onChange={handleAdicionarTipoAcidente}
                                        value={tiposAcidentesSelecionados}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Selecione Tipos de Acidentes"
                                            />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((tipo_acidente, index) => (
                                                <Chip
                                                    key={index}
                                                    label={tipo_acidente.nome}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                    onDelete={(event) => handleRemoverTipoAcidente(event, tipo_acidente)}

                                                />
                                            ))
                                        }
                                    />


                                </Grid>
                            </Grid>
                        }

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={7}
                            style={{ marginTop: 5 }}
                        >
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                align="center"
                                item xs={12} >
                                <Autocomplete
                                    id="select-colaborador"
                                    options={colaboradores}
                                    disableCloseOnSelect
                                    getOptionLabel={(colaborador) => returnDescricaoColaborador(colaborador)}
                                    value={colaboradorSelecionado}
                                    onChange={(e, v) => setColaboradorSelecionado(v)}
                                    renderInput={(params) => (
                                        <TextField {...params} label=" Responsável "

                                            multiline
                                            minRows={3} />
                                    )}
                                />
                            </Grid>
                        </Grid>




                        <Grid item xs={12}
                            container
                            alignItems="center"
                            justifyContent="center"

                        >

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="dataOcorrencia"
                                    label="Data da Identificação"
                                    id="dataOcorrencia"
                                    value={dataOcorrencia}
                                    onChange={(e) => setDataOcorrencia(e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="horaOcorrencia"
                                    label="Hora da Identificação"
                                    id="horaOcorrencia"
                                    value={horaOcorrencia}
                                    onChange={(e) => setHoraOcorrencia(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                        </Grid>

                        <TextField
                            label="Valor"
                            type="number"
                            inputProps={{ step: "1", min: "0" }} // só inteiros >= 0
                            value={valor}
                            onChange={(e) => setValor(e.target.value)}
                            variant="outlined"
                            margin="normal"
                        />


                        {
                            tipoOcorrencia === 20 &&
                            (
                                <Grid item xs={6}>
                                    <TextField
                                        variant="standard"
                                        name="veiculosEnvolvidos"
                                        label="Veículos Envolvidos"
                                        id="veiculosEnvolvidos"
                                        value={veiculosEnvolvidos}
                                        onChange={(e) => setVeiculosEnvolvidos(e.target.value)}
                                        fullWidth
                                        multiline
                                        minRows={3}
                                    />
                                </Grid>

                            )
                        }

                        {
                            tipoOcorrencia === 20 &&
                            (
                                <Grid item xs={6}>
                                    <TextField
                                        variant="standard"
                                        name="pessoasEnvolvidas"
                                        label="Pessoas Envolvidas"
                                        id="pessoasEnvolvidas"
                                        value={pessoasEnvolvidas}
                                        onChange={(e) => setPessoasEnvolvidas(e.target.value)}
                                        fullWidth
                                        multiline
                                        minRows={3}
                                    />
                                </Grid>

                            )
                        }


                        {
                            tipoOcorrencia === 20 &&
                            (
                                <Grid item xs={6}>
                                    <TextField
                                        variant="standard"
                                        name="localAcidente"
                                        label="Local Acidente"
                                        id="localAcidente"
                                        value={localAcidente}
                                        onChange={(e) => setLocalAcidente(e.target.value)}
                                        fullWidth
                                        multiline
                                        minRows={3}
                                    />
                                </Grid>

                            )
                        }

                        {
                            tipoOcorrencia === 20 &&
                            (
                                <Grid item xs={6}>
                                    <TextField
                                        variant="standard"
                                        name="usoCinto"
                                        label="Uso do Cinto de Segurança"
                                        id="localAcidente"
                                        value={usoCinto}
                                        onChange={(e) => setUsoCinto(e.target.value)}
                                        fullWidth
                                        multiline
                                        minRows={3}
                                    />
                                </Grid>

                            )
                        }


                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                name="descricao"
                                label="Descrição"
                                id="descricao"
                                value={descricao}
                                onChange={(e) => setDescricao(e.target.value)}
                                fullWidth
                                multiline
                                minRows={3}
                            />
                        </Grid>







                    </Grid>


                    {
                        (tipoOcorrencia === 10 || tipoOcorrencia === 20 ) &&
                        (
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={12}
                                style={{ marginTop: 5 }}
                            >
                                <IconButton onClick={handleOpen} color="primary" aria-label="Adicionar Questão">
                                    <AddIcon />
                                    Despesa
                                </IconButton>
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    align="center"
                                    item xs={11}
                                >

                                    <Autocomplete
                                        id="select-despesas"
                                        options={despesas}
                                        disableCloseOnSelect
                                        multiple
                                        getOptionLabel={(despesa) => returnDescricaoDespesa(despesa).replace(/<br \/>/g, '\n')}
                                        value={despesas}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((despesa) => {
                                                const cotacaoText = returnDescricaoDespesa(despesa).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label=" Despesas " multiline minRows={1} />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((despesa, index) => (
                                                <Chip
                                                    key={index}
                                                    label={returnDescricaoDespesa(despesa)}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                    onDelete={(event) => handleRemoverDespesa(event, despesa)}

                                                />
                                            ))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        )
                    }



                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={12}
                        style={{ marginTop: 5 }}
                    >
                        <AnexadorArquivos
                            ref={anexadorRef}
                            flag={flag}
                            isOcorrencia={true}
                            objeto={flag === 1 ? ocorrenciaAtualizar : null}
                            id={flag === 1 ? ocorrenciaAtualizar.id_ocorrencia : idOcorrenciaSalva}
 
                            close={closeNovaOcorrencia}

                        />
                    </Grid>


                </Grid>
            }

            <Dialog open={anchorEl} onClose={handleClose} >
                <DialogTitle>Inserir Despesa</DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        align="flex-start"
                        item xs={12}
                        style={{ marginTop: 1 }}
                    >

                        <Box sx={{ p: 2, width: 600 }}>
                            <TextField
                                label="Nome"
                                value={nomeDespesa}
                                onChange={(e) => setNomeDespesa(e.target.value)}
                                variant="outlined"
                                margin="normal"
                            />
                            <TextField
                                label="Descrição"
                                value={descricaoDespesa}
                                onChange={(e) => setDescricaoDespesa(e.target.value)}
                                variant="outlined"
                                margin="normal"
                                multiline
                                minRows={3}
                            />

                            <TextField
                                label="Unidade"
                                value={unidadeDespesa}
                                onChange={(e) => setUnidadeDespesa(e.target.value)}
                                variant="outlined"
                                margin="normal"
                            />

                            <TextField
                                label="Valor Unidade"
                                type="number"
                                inputProps={{ step: "0.01", min: "0" }} // só números decimais >= 0
                                value={valorUnidadeDespesa}
                                onChange={(e) => setValorUnidadeDespesa(e.target.value.replace(",", "."))}
                                variant="outlined"
                                margin="normal"
                            />

                            <TextField
                                label="Quantidade"
                                type="number"
                                inputProps={{ step: "1", min: "0" }} // só inteiros >= 0
                                value={quantidadeDespesa}
                                onChange={(e) => setQuantidadeDespesa(e.target.value)}
                                variant="outlined"
                                margin="normal"
                            />

                            <TextField
                                label="Valor Total"
                                value={
                                    valorUnidadeDespesa && quantidadeDespesa
                                        ? (parseFloat(valorUnidadeDespesa) * parseFloat(quantidadeDespesa)).toFixed(2)
                                        : "0.00"
                                }
                                variant="outlined"
                                margin="normal"

                            />




                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 2 }}
                                onClick={(e) => handleAdicionarDespesa()}
                            >
                                Inserir
                            </Button>
                        </Box>
                    </Grid>
                </DialogContent>
            </Dialog>


        </>
    );
}


